module.exports = __webpack_public_path__ + "static/giraffesuitcase-9067b0230b1ff3ab6b03ebcc9474ecbc.jpeg";